module.exports = __webpack_public_path__ + "fonts/Roboto-BoldItalic.fd6e9700.ttf";